(() => {
  const anchorScrollTrigger = 'a[href^="#"]';

  const init = () => {
    $('body')
      .on('click', anchorScrollTrigger, anchorScroll);
  }

  const anchorScroll = (e) => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    const elementClicked = $element.attr("href");
    const destination    = $(elementClicked).offset().top;
    const offsetDefault  = $element.attr("data-offset");

    let offset = 0;
    if ( offsetDefault > 0 ) {
      offset = offsetDefault;
    } else {
      offset = 0;
    }

    $("html:not(:animated), body:not(:animated)").animate({
      scrollTop: destination - offset
    }, 500);
  }

  $(init);
})();
